import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { combineLatest } from 'rxjs';

import { Voucher } from '../classes/index';
import { saveAs} from 'file-saver';
import { environment } from '../../environments/environment';

import algoliasearch from 'algoliasearch';


@Injectable()
export class VoucherService {

	searchClient = algoliasearch(
		environment.algoliasearch.appId,
		environment.algoliasearch.apiKey
	);
    indexVouchers = this.searchClient.initIndex('vouchers');
	constructor(private firestore: Firestore) {
		console.log('VoucherService initialization...');
	}

	downloadJournal(url){
		return new Promise(resolve => {
			saveAs(url, 'Journal.png')
			resolve(true)
		})
	}

	listVouchers(){
		return collectionData(query(collection(this.firestore, 'vouchers')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new Voucher();
				object.fromJSON(data);
				return object;
			});
		}));
	}

	getVouchersByIds(voucherIds){
		let refList = [];
		for(let id of voucherIds){
			refList.push(docData(doc(this.firestore, `vouchers/${id}`)));
		}
		return combineLatest(refList);
	}

	getVoucher(voucherId){
		return docData(doc(this.firestore, `vouchers/${voucherId}`))
		.pipe(map(data => {
			let voucher = new Voucher();
			voucher.fromJSON(data);
			return voucher;
		}));
	}

	addVoucher(voucher) {
		return addDoc(collection(this.firestore, 'vouchers'), {...voucher});
	}

	async addMultipleVouchers(vouchers){
		var batch = writeBatch(this.firestore);
		let count = 0;
		for (let i = 0; i < vouchers.length; i++) {
			let voucherRef = doc(collection(this.firestore, 'vouchers'));
			batch.set(voucherRef, { ...vouchers[i] });
			count++
		}
		console.log('voucherNbr :'+count);
		if(count > 0) await batch.commit();
		console.log('batchAdd Vouchers finished');
	}

	deleteVoucher(voucherId) {
		return deleteDoc(doc(this.firestore, `vouchers/${voucherId}`));
	}

	async setLmDate(vouchers){
		var batch = writeBatch(this.firestore);
		let count = 0;
		for(let i = 0; i < vouchers.length; i++){
			console.log('Update voucher:'+vouchers[i].id);

			batch.update(doc(this.firestore, `vouchers/${vouchers[i].id}`),
					{lastUpdateDate: new Date().getTime()});
			count++;
			if(count>=100){
				await batch.commit();
				batch = writeBatch(this.firestore);
			}
		}
		if(count>0){
			await batch.commit();
		}
	}

	/*

	updateTheme(themeUid, data){
		return this.afs.collection('themes').doc(`${themeUid}`).update(data);
	}*/

	async isUniqueIdValid(id){
		const ref = collectionData(query(collection(this.firestore, 'vouchers'), where('code', '==', id.toUpperCase())), { idField: 'id' });
		return ref.pipe(map(collection => {
			return collection.length > 0;
		}));
	}
}
